module.exports = __webpack_public_path__ + "static/media/education3.5f008041.png";